export default {
    workOrder_driverSelector_title: "Select Driver",
    workOrder_driverSelector_scheduledAt: "Scheduled At",
    workOrder_driverSelector_driver: "Driver",
    workOrder_driverSelector_unit: "Unit",
    workOrder_driverSelector_unassigned: "Unassigned",
    workOrder_driverSelector_driversAvailable: "Drivers Available in the selected range",
}